import Schema from 'AppReact/schema';
import { makeReadyCard, assignTech, assignVendor, admin } from 'types'
import { selectedItem, selectedCatgegory } from '../../apps/admin/makeReadyBoard/types'

export default {
  isOpenAssignDropdown: Schema('boolean', 'primitive', { defaultValue: false }),
  isOpenScheduleDropdown: Schema('boolean', 'primitive', { defaultValue: false }),
  isOpenCompletionDropdown: Schema('boolean', 'primitive', { defaultValue: false }),
  selectedItems: Schema(selectedItem, 'array', { defaultValue: [] }),
  selectedCategories: Schema(selectedCatgegory,'array', { defaultValue: [] }),
  assignedTechId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  assignedVendorId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),
  admins: Schema(admin, 'array', { defaultValue: [] }),
  vendors: Schema(assignVendor, 'array', { defaultValue: [] }),
  searchVal: Schema('string', 'primitive', { defaultValue: '' }),
  selectedTab: Schema('string', 'primitive', { defaultValue: '' }),
  hideAdmins: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hideTechs: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hideVendors: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
}
